import React, { useCallback, useEffect, useState } from "react"
import styled from "styled-components"
import { useForm } from "react-hook-form"
import Modal from "@motorata/base-ui.components.molecules.modal"
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import Button from "@motorata/base-ui.components.atoms.button"
import Input from "@motorata/base-ui.components.atoms.input";
import { EMAIL_REGEX } from "@motorata/base-ui.utils.regex";
import Link from "next/link";
import Checkbox from "@motorata/base-ui.components.atoms.checkbox";
import { AnalyticsService } from "@motorata/base-ui.services.segment-service";
import { LeadService } from "@motorata/base-ui.services.api-service";
import { SentryService } from "@motorata/base-ui.services.sentry-service";
import { usePathname } from "next/navigation";

const OfferModalReportContent = ({ show, setShow }) => {
  const pathname = usePathname()
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm()

  const checkbox = watch("checkbox");

  const [loading, setLoading] = useState(false)

  const onSubmit = useCallback(
    async el => {
      try {
        setLoading(true)
        await LeadService.add("report_offer", {
          firstName: el.firstName,
          email: el.email,
          message: `https://motorata.pl${pathname} ${el.message}`,
        })
        AnalyticsService.track("Offer Report Send")
        setShow()
      } catch (e) {
        SentryService.error("[ERROR LeadService.add[report_offer] API]", e);
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  useEffect(() => {
    if (show) {
      AnalyticsService.track("Offer Report Open")
    }
    if(!show){
      reset()
    }
  }, [show])

  return (
    <>
      <Content onSubmit={handleSubmit(onSubmit)}>
        <StyledGrid>
          <Input
            name="firstName"
            label="Imię*"
            error={errors.firstName}
            value={watch('firstName')}
            rhf={register("firstName", {
              required: true
            })}
          />
          <Input
            name="email"
            label="E-mail*"
            error={errors.email}
            value={watch('email')}
            rhf={register("email", {
              required: true,
              pattern: {
                value: EMAIL_REGEX,
                message: "Niepoprawny format email",
              },
            })}
          />
        </StyledGrid>
        <Input
          name="message"
          label="Dodatkowa wiadomość"
          error={errors.message}
          multiline={true}
          rows={4}
          maxRows={4}
          value={watch('message')}
          rhf={register("message")}
          marginBottom="S"
        />
        <Box mb="20px">
          <Checkbox
            name="checkbox"
            value={checkbox}
            error={errors.checkbox}
            rhf={register("checkbox", {
              required: true,
            })}
          >
            *Oświadczam, że zapoznałem/-am się z <Link href="/regulamin">Regulaminem</Link> i <Link href="/polityka-prywatnosci">Polityką prywatności</Link> oraz akceptuję ich postanowienia.
          </Checkbox>
        </Box>
        <Button loading={loading} submit width="100%">
          Wyślij
        </Button>
      </Content>
    </>
  )
}

const OfferModalReport = ({ show, setShow }) => {
  return (
    <Modal title="Zgłoś naruszenie" show={show} setShow={setShow} maxWidth="600px">
      <OfferModalReportContent show={show} setShow={setShow} />
    </Modal>
  )
}

export default OfferModalReport

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.S};
  margin-bottom: ${({ theme }) => theme.space.S};

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const Content = styled.form``
